const ALL_FEATURES = {
    SPLIT_PAGE: 'split_page',
}

const DEV_FEATURES = {
    [ALL_FEATURES.SPLIT_PAGE]: false,
}

const STG_FEATURES = {
    [ALL_FEATURES.SPLIT_PAGE]: true,
}

const YOKOHAMA_FEATURES = {
    [ALL_FEATURES.SPLIT_PAGE]: true,
}

export {
    DEV_FEATURES,
    STG_FEATURES,
    YOKOHAMA_FEATURES
}